<template>
    <div class="relative z-10 inline-block text-left"
         v-click-outside="hideDropdown">
        <div class="pr-1">
            <button type="button"
                    class="select-none inline-flex justify-center items-center w-full rounded-md border border-gray-300 shadow-sm py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500 transition duration-300"
                    :class="[noLabel ? 'pl-2 pr-3' : 'px-4']"
                    id="menu-button" aria-expanded="true" aria-haspopup="true"
                    @click.prevent="dropdownOpen = !dropdownOpen">
                <slot>{{ !noLabel ? label : null }}</slot>
                <!-- Chevron Down Icons -->
                <icon-chevron-down class="ml-1 h-4 w-4 transform transition duration-300"
                                   :class="dropdownOpen ? 'rotate-90' : ''"></icon-chevron-down>
            </button>
        </div>
        <!-- Dropdown Options -->
        <transition enter-active-class="transition ease-out duration-100"
                    enter-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95">
            <div v-show="dropdownOpen"
                 :class="popoutOrigin()"
                 class="absolute right-0 mt-2 py-1 w-56 rounded-md shadow-xl bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-600 focus:outline-none"
                 role="menu"
                 aria-orientation="vertical"
                 style="border-top: 3px solid rgb(226, 27, 34);"
                 aria-labelledby="menu-button" tabindex="-1"
                 @click.prevent="emitEvent">
                <slot name="buttonOptions" :hideDropdown="hideDropdown"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "TailwindSimpleDropdown",
    props: {
        label: {
            type: String,
            required: false,
            default: "Options"
        },
        origin: {
            type: String,
            required: false,
            default: "top-left"
        },
        noLabel: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            dropdownOpen: false
        };
    },
    methods: {
        popoutOrigin () {
            if (this.origin === "top-right") {
                return "origin-top-right right-0";
            }
            return "origin-top-left left-0";
        },
        hideDropdown () {
            if (this.dropdownOpen) {
                this.dropdownOpen = false;
            }
        },
        emitEvent (event) {
            this.$emit("input", event.target.value);
            this.hideDropdown();
        }
    },
};
</script>
